"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DASH = exports.SITE_NAME = void 0;
exports.SITE_NAME = '| Lokalportal';
exports.DASH = '–'; // This is an "en dash" not a minus sign
exports.default = {
    addToCalender: {
        appleCalender: 'Apple Calendar',
        google: 'Google',
        outlook: 'Outlook',
        text: 'Add to calendar',
    },
    appState: {
        appStartNoConnectionToServerNote: 'There seems to be a problem with the internet connection.',
        restartAction: 'The app is restarted',
        restartReason: 'Oh dear... there\'s been a bug in the app. It needs to be restarted.' +
            'We will fix the error as soon as possible.',
        updateActionUpdateLater: 'Later',
        updateActionUpdateNow: 'Update now',
        updateAvailableBody: 'Update your app now and check out the latest features.',
        updatePermanentlyUnavailableBody: 'Unfortunately, there is no new version available for your phone.',
        updatePermanentlyUnavailableTitle: 'Version is not supported',
        updateRequiredBody: 'Please update your app so you can get going again.',
        updateRequiredTitle: 'Version is not supported',
        updateTemporarilyUnavailableBody: 'We are currently working on our servers. Please check back later.',
        updateTemporarilyUnavailableTitle: 'Temporarily not available',
    },
    authentication: {
        agb1: 'Our',
        agb2: 'Privacy policy',
        agb3: ' you are able',
        agb4: 'here',
        agb5: ' see.',
        ageConfirmation1: 'I hereby agree to the',
        ageConfirmation2: 'Terms of use',
        ageConfirmation3: ' and confirm that I am of legal age.',
        ageConfirmationError: 'Please agree to our terms of use.',
        alreadyRegistered: 'I already have a profile',
        confirmPasswordReset: 'reset password',
        errorAddress: 'Please check your address.',
        errorAutomaticLoginModalBody: 'It\'s good to have you back. 🤗 Just log back in now.',
        errorLogin: 'Your credentials are incorrect.',
        errorLoginModalBody: 'Please check your email address and password.',
        errorLoginModalTitle: 'Login failed',
        errorMissingEmail: 'Please enter your e-mail address.',
        errorMissingPassword: 'Please enter your password.',
        errorOAuthLoginUserDeniedAuthorization: 'Access denied.',
        errorOAuthLoginUserNotRegistered: 'Please register first so that you can log in.',
        errorPassword: 'Please check your password.',
        errorPasswordReset: 'Sorry, we couldn\'t send you an email.' +
            'Please try again later.',
        errorRepeatPassword: 'The passwords entered do not match.',
        facebookRegistrationEmailSubTitle: 'Please enter your e-mail address:',
        facebookRegistrationEmailTitle: 'E-mail address missing',
        internetConnectionProblemBody: 'Please check your internet connection and try again.',
        internetConnectionProblemTitle: 'No internet connection',
        loginTitle: 'It\'s good to have you back!',
        loginWithApple: 'Log in with Apple',
        loginWithFacebook: 'Log in with Facebook',
        newPassword: 'New password',
        newPasswordRepeat: 'Repeat new password',
        passwordChanged: 'Your password has been successfully changed.',
        passwordChangedLongText: 'You can now log in with your email address and your new password.',
        passwordForgot: 'Password forgotten?',
        passwordForgotBody: 'It can happen to anyone... Just enter your email address below,' +
            'then we will send you an email to reset your password.',
        passwordResetTitle: 'Reset password?',
        registerLopo: 'Register now on the local portal',
        registerNow: 'Register now for free',
        registerWithApple: 'Register with Apple',
        registerWithFacebook: 'Register with Facebook',
        repeatPassword: 'Repeat password',
        resetConfirmationBody: 'We have sent you an email. Please follow the link in the email,' +
            'to reset your password.',
        resetConfirmationTitle: 'You\'ve got mail!',
        sendEmail: 'Send email',
        wantRegister: 'I would like to register',
    },
    blacklist: {
        blacklist: 'Block',
        forEver: 'Forever',
        modalContent: 'If you block a neighbor, you will no longer be able to see each other\'s posts in the newsfeed.' +
            'and no longer send you private messages. In your settings under "Blocked' +
            'Neighbors" you can undo this process at any time.',
        modalTitle: 'Confirm blocking',
        modalTitleRemove: 'Blocked neighbors',
        profile: 'Block users',
        revertBlacklist: 'Stop blocking users',
        wizardExplanation: 'Here you can see your blocked neighbors.' +
            'With a click on the circle you can undo this setting.',
        wizardHeaderText: 'Blocked neighbors',
    },
    comments: {
        attachImage: 'Add images',
        comment: 'Comment',
        commentCount: (count) => `${count} ${count === 1 ? 'comment' : 'comments'}`,
        disabled: 'Comments have been disabled',
        discardChanges: 'discard changes',
        edit: 'Edit comment',
        editCancel: 'Cancel editing the comment',
        editCancelAlert: 'Do you really want to discard your changes?',
        editCancelCTA: 'Cancel',
        editCancelText: 'Editing the comment',
        editError: 'Your comment could not be edited. Please try again.',
        edited: (date) => `{ "edit" - ${date}}`,
        nonYetMessage: 'Share what you think about this post.',
        noneYet_APP: 'No comments here yet.',
        noneYet_WEB: 'No comments yet',
        placeHolder_APP: 'Your comment',
        placeHolder_WEB: 'Write a comment',
        remove: 'Delete comment',
        removeError: 'Your comment could not be deleted. Please try again.',
        removedByAdmin_APP: 'This comment has been deleted by an administrator.',
        removedByAdmin_WEB: 'This comment was deleted by a moderator.',
        removedByAuthor: 'This comment has been deleted by its author.',
        removedByCommentableAuthor_APP: 'This comment has been deleted by the author of the post.',
        removedByCommentableAuthor_WEB: 'This comment was deleted by the author of the related post.',
        removedByUnknown: 'This comment has been deleted.',
        submit: 'Send comment',
        submitError: 'Your comment could not be sent. Please try again.',
        sureToRemove: 'Are you sure you want to delete this comment?',
        total: 'Total',
        update: 'Update comment',
        write: 'Write a comment',
    },
    cookieConsent: {
        linkText: 'Use of Cookies.',
        message: 'To provide you with a better user experience, we use cookies.' +
            'By using Local Portal you agree to the',
    },
    createFlag: {
        messagePlaceholder: 'Share your concerns with us.',
        reason: 'Reason',
        submitTitle: 'Your post has been reported',
        successText: 'You have successfully reported the post. We will check it as soon as possible. Thank you very much!',
        text: 'You have concerns about the content of this post?' +
            ' Then you can report the post here and we will review it as soon as possible.' +
            ' The author of the contribution will not be informed of the notification.',
        title: 'Report post',
    },
    dateFormat: {
        around: (prefix, date) => `${prefix}, ${date}`,
        at: 'at',
        between: (from, to) => `${from} - ${to}`,
        clock: 'Watch',
        eventFeed: 'dd. DD.MM.YYYY',
        eventFeedHeaderLong: 'ddd, DD. MMMM YYYY',
        eventFeedHeaderRangeLong: 'DD. MMM YYYY',
        eventFeedHeaderRangeShort: 'DD. MMM',
        eventFeedHeaderShort: 'DD. MMMM YYYY',
        from: 'From',
        // will be used for relative times like "In 10 Minuten"
        future: (relTime) => `In ${relTime}`,
        // will be used if the relative time is less than 45 seconds in the past
        // (see https://momentjs.com/docs/#/customization/relative-time-threshold/)
        justNow: 'Just now',
        last: 'Last',
        onTheWeekend: 'At the weekend',
        ongoing: 'Taking place right now',
        // will be used for relative times like "Vor 10 Minuten"; special handling for the
        // "just now" case, see definition of property 's' below
        past: (relTime) => relTime === 'Gerade eben' ? 'Gerade eben' : `Before ${relTime}`,
        short: 'DD.MM.YYYY',
        timeOnly: 'H:mm [o\'clock]',
        tiny: 'DD.MM.YY',
        to: 'By',
        today: 'Today',
        tomorrow: 'Morning',
        withDayOfWeekLong: 'dddd, DD. MMM YYYY',
        withDayOfWeekShort: 'dddd, DD.MM.YYYY',
        yesterday: 'Yesterday',
    },
    datePicker: {
        buttonOK: 'Take over',
        buttonReset: 'Reset',
        selectEndDate: 'Select period and',
        shortFriday: 'Fri',
        shortMonday: 'Mon',
        shortSaturday: 'Sat',
        shortSunday: 'So',
        shortThursday: 'Do',
        shortTuesday: 'Tue',
        shortWednesday: 'Mi',
    },
    emojiMart: {
        activity: 'Activity',
        custom: 'Local portal',
        flags: 'Flags',
        foods: 'Food & Drink',
        nature: 'Animals & Nature',
        notfound: 'No results',
        objects: 'Items',
        people: 'Emojis & People',
        places: 'Travel & Places',
        recent: 'Last',
        search: 'Search',
        symbols: 'Symbols',
    },
    eventParticipants: {
        deleteModalBody: 'Do you really not want to attend the event anymore?',
        deleteModalButton: 'No longer participate',
        deleteModalTitle: 'No longer participate?',
        iWantToParticipate: 'I would like to participate',
        imParticipating: 'I participate',
        justYou: 'You participate',
        participants: 'Participant',
        showParticipantsList: 'Show list of participants',
        you: 'You',
    },
    eventfeed: {
        feedLoadingError: 'The events could not be loaded.',
        freeDateChoice: 'Freely selectable',
        itemLoadingError: 'This event could not be loaded',
        myEvents: 'My events',
        noEventsAvailable: 'Unfortunately there are no events for this period yet.',
        relatedContentSubtitle: 'That\'s what\'s going on with you in the next few days.',
    },
    feedback: {
        acceptAndSubmit: 'Agree and send',
        emailPlaceholder: 'Your email address',
        errorInputRequired: 'Please enter your feedback.',
        errorSending: 'Oops... Your feedback could not be sent.',
        message: 'You noticed a mistake, you have new ideas or questions?' +
            'Then feel free to send us a message.',
        messagePlaceholder: 'Your feedback',
        onboardingErrorFeedbackPlaceholder: 'So that we can always improve Lokalportal,' +
            'we\'d love to hear from you.',
        onboardingErrorFeedbackTitle: 'We\'re sorry, something\'s gone wrong.' +
            'Please send us your feedback so that we can solve the problem as soon as possible.',
        terms: 'I agree to the storage of my data for the purpose of processing and responding to my enquiry, as well as' +
            'of possible follow-up questions. I can object to this at any time. For this purpose, an e-mail to:' +
            'kontakt@lokalportal.de',
        thanksMessage: 'Thank you for your feedback! We will get back to you as soon as possible.' +
            'Please also have a look at our blog, there you will find answers to the following questions',
        thanksMessageLink: 'most common questions',
        thanksTitle: 'Thanks a lot!',
        title: 'Help us with your feedback',
    },
    follow: {
        follow: 'Follow',
        followAlertMessage: (profileName) => `You follow "${profileName}" now.`,
        following: 'Subscribed',
        noFollowersMessage: 'You can change that very quickly! Introduce yourself on the local portal,' +
            'keep your neighbours informed and also tell people from your town about your profile.' +
            'Soon this place will be a madhouse.',
        noFollowersTitle: 'No subscribers in sight yet? 👀 🔍',
        showFollowers: 'Show subscribers',
        turnOffNotifications: 'Turn off notifications',
        turnOnNotifications: 'Turn on notifications',
        unfollow: 'Do not subscribe anymore',
        unfollowAlertBody: (profileName) => `If you no longer subscribe to ${profileName},` +
            'you will no longer receive notifications about the user\'s news and' +
            'you won\'t find them on your home page at the very first glance.',
        unfollowAlertTitle: 'No longer subscribe?',
    },
    graylist: {
        graylist: 'Muted 🤐',
        modalTitle: 'Muted profiles 🤐',
        mute: 'Mute',
        remainingDays: (days) => `Still ${days === 1 ? '1 day' : `${days} days`}`,
        revertGraylist: 'Profile no longer mute',
        successMessage: (profileName, durationInDays) => `Posts by "${profileName}" will now be ${durationInDays === 1 ? '1 day' : `${durationInDays} days`}` +
            'is no longer displayed. You can change this in the settings.',
        wizardExplanation: 'Here you can see all profiles that you have muted. With' +
            'You can undo this setting by clicking on the small speaker.',
        yet: 'Still',
    },
    groups: {
        confirmMember: 'Add group member',
        confirmMemberFail: (name) => `An error occurred while adding "${name}".`,
        confirmMemberSuccess: (name) => `You added the group member "${name}".`,
        confirmations: {
            accept: {
                body: 'Are you sure you want to accept this user',
                buttonConfirm: 'Confirm',
                title: 'Confirm accept',
            },
            reject: {
                body: 'Are you sure you want to reject this user?',
                buttonConfirm: 'Confirm',
                title: 'Confirm decline',
            },
            remove: {
                body: 'Are you sure you want to remove this member?',
                buttonConfirm: 'Confirm',
                title: 'Confirm removal',
            },
        },
        confirmedUsers: "Group participants",
        ctaBlocked: {
            buttonLabel: 'To the newsfeed',
            info: 'Access to groups is only possible for neighbours and editors.' +
                'Just switch to your private profile.',
            title: 'For neighbours only',
        },
        ctaNotJoinedFeed: {
            infoCanJoin: 'Join this group if you want to talk about it with other neighbors.',
            infoCanNotJoin: 'Sorry, you can\'t join this group because it\'s outside your region.',
            infoLoggedOut: 'Register now and join this group if you want to' +
                'you want to talk about it with other neighbors.',
            title: 'Sound interesting?',
        },
        ctaNotJoinedMembers: {
            infoCanJoin_APP: (groupName) => `Once you have joined the group ${groupName}, you will be able to` +
                'and exchange ideas with them.',
            infoCanJoin_WEB: 'Once you have joined the group, you will be able to' +
                'and exchange ideas with them.',
            infoCanNotJoin: 'Sorry, you can\'t see the group members of this group,' +
                'because it\'s outside your region.',
            title_APP: 'You are not yet a member of this group.',
            title_WEB: (groupName) => `Would you like to join the group "${groupName}"?`,
        },
        ctaRecommendation: {
            body: 'You\'re a big dog fan and want to talk to your neighbors about' +
                'your four-legged friends? Or are you interested in photography and would like to' +
                'want to build a photo community together with others? Suggest your group now! Fill out' +
                'the fields and send us your proposal. We will get back to you as soon as possible.',
            groupDescriptionInput: 'Describe your group',
            groupNameInput: 'Name of the group',
            header: 'Propose group',
            title: 'Your favorite topic is not yet included?',
        },
        eliminateMember: 'Remove group member',
        eliminateMemberFail: (name) => `An error occurred while removing "${name}".`,
        eliminateMemberSuccess: (name) => `You removed the group member "${name}".`,
        groupNotFoundError: 'This group was not found.',
        groups: 'Groups',
        groupsInMyRegion: 'Groups in my region',
        inviteNeighborSubtitle: 'Add neighbors and friends',
        inviteNeighborTitle: 'Invite your neighbors',
        joinClosedGroupError: (groupName) => `An error occurred while requesting access the group ${groupName}.`,
        joinClosedGroupModal: {
            confirm: 'Request',
            message: 'You hereby submit a request to join this private group, which will be handled by an administrator. ' +
                'Once you have been accepted, you will be able to view and create posts.',
            title_APP: (groupName) => `Join „${groupName}“?`,
            title_WEB: (groupName) => `Join „${groupName}“?`,
        },
        joinClosedGroupSuccess: (groupName) => `Your request to the group "${groupName}" has been sent.`,
        joinGroup: 'Join',
        joinGroupError: (groupName) => `An error occurred while joining the group ${groupName}.`,
        joinGroupSuccess: (groupName) => `You are now a member of the group "${groupName}".`,
        leaveGroup: 'Leave group',
        leaveGroupError: (groupName) => `An error occurred while leaving the group ${groupName}.`,
        leaveGroupModal: {
            confirm: 'Leaving',
            message: 'If you leave the group, you will no longer be able to see posts in that group.' +
                'You will also no longer receive notifications about what is happening in the group.',
            title_APP: (groupName) => `"${groupName}" really leave?`,
            title_WEB: (groupName) => `Do you really want to leave the group "${groupName}"?`,
        },
        leaveGroupSuccess: (groupName) => `Successfully left group "${groupName}".`,
        loadGroupError: 'The group could not be loaded.',
        memberCount: (count) => `${count} ${count === 1 ? 'member' : 'members'}`,
        memberCountHeader: (count) => `${count} group members`,
        memberListAdminSection: 'Administrators',
        memberListMemberSection: 'Group members',
        moreGroups: 'Other groups',
        moreGroupsEmpty: 'Unfortunately there are no groups here yet.',
        myGroups: 'Your groups',
        notifications: {
            changeError: `An error has occurred. Please try again later.`,
            changeSuccess: (groupName, enabled) => `The notifications for the ${groupName} group are ${enabled ? 'enabled' : 'disabled'}.`,
            label: 'Notifications',
        },
        pending: 'Your request needs to be accepted by an administrator before you can view and create posts.',
        pendingGroups: 'Pending groups',
        pendingUsers: 'Pending users',
        recommendationSubtitle: 'Propose a new group',
        recommendationSuccessBody: 'We will do our best to answer you as soon as possible.',
        recommendationSuccessTitle: 'Your proposal is on its way to us.',
        recommendationTitle: 'Your favorite topic is missing?',
        sendRecommendationBody: (title, description) => `Request: New Group \nTitle: ${title} \nDescription: ${description}`,
        shareGroup: 'Share group',
        shareGroupMessage: 'Check it out. I found this group on the local portal,' +
            'that might be interesting for you, too.',
        showMemberList: 'Show group members',
    },
    header: {
        events: 'Events',
        groups: 'Groups',
        mainPage: 'Home page',
        notifications: 'Notifications',
        profilesDirectory: 'Search',
    },
    imageAlt: {
        addImage: 'Add image',
        addedMedia: 'Added media',
        avatar: 'Avatar',
        campaignLoading: 'Campaign invites',
        campaignSuccess: 'Campaign success',
        contactPerson: 'Contact',
        headerImage: 'Header image',
        imageCropper: 'Crop image',
        linkPreview: 'Link preview',
        loadingSpinner: 'Loading progress',
        markerImage: 'Map marker',
        poweredByGoogle: 'Supported by Google',
        snapshotPreview: 'Snapshot preview',
        staticMap: 'Map',
        success: 'Success',
    },
    intermediateProfile: {
        completeProfile: {
            body: 'Complete your profile now so that you can use all the functions in the local portal.',
            bodyTitle: 'Almost there...',
            title: 'Complete profile',
        },
        confirmEmail: {
            body1: 'Please confirm your email address',
            body2: '. Also check your spam folder if you can\'t find it.' +
                'If you have any problems please write us a message to',
            bodyTitle: 'Check your mailbox...',
            buttonText: 'Resend confirmation email',
            title: 'Confirm email',
        },
        register: {
            body: 'Register now and you will be able to read the posts of your neighbours' +
                'and exchange ideas with them.',
            bodyTitle: 'Come on in',
            loginButton: 'Log in',
            registerButton: 'Register now',
            title: 'Neighborhood',
        },
        verify: {
            body: 'Only after you have verified yourself, you can connect with your neighbours everywhere in the local portal.' +
                'exchange.',
            bodyTitle: 'Join in now!',
            button: 'Verify now',
            title: 'Verify profile',
        },
    },
    item: {
        deletePost: 'Delete post',
        deletePostConfirmationQuestion: 'Do you really want to delete the post?',
        duplicatePost: 'Duplicate post',
        editPost: 'Edit post',
        keepAddress: 'Take over address',
        notFound: 'Oops... the post is unfortunately\no longer there.',
        notFoundTitle: 'Post not found',
        snapshotUpdatingError: 'The snapshot could not be edited.',
        updatingError: 'The post could not be updated.',
    },
    landingPage: {
        info: 'In the local portal, you can find out at a glance what is happening in your area.',
        learnMore: 'Learn more',
        notFound: 'The page was unfortunately not found :(',
        return: 'Back to Local Portal',
        title: 'What\'s new in the neighborhood?',
    },
    locationChanger: {
        addressNotFound: 'Please enter the complete address with street and city!',
        areaNotReleased: 'The entered location is not yet unlocked. Please enter another location!',
        areaNotReleasedAlertBody: 'Unfortunately Lokalportal is not yet available in this region.',
        areaNotReleasedAlertTitle: 'We are not there yet',
        areaNotReleasedShort: 'Sorry, this place is not unlocked yet.',
        brokenAddress: 'Invalid address',
        currentLocation: 'Current location',
        defaultError: 'The entered location is invalid. Please enter another location!',
        enableGeolocationInfo: 'Allow us access to your location first.' +
            'Just go to your settings to do this.',
        fetchLocationError: 'Your location could not be determined.',
        headerLocationChanger: 'Choose location',
        homeLocation: 'My address',
        inputPlaceholder: 'Address or place',
        invalidParameters: 'Please try again, or enter a different location!',
        outOfReach: 'The entered location is outside the allowed range. Please enter another location!',
        outOfReachBody: 'The location is outside the permitted area.',
        outOfReachTitle: 'Please enter another location!',
        popularPlaces: 'Popular places',
        removeAddress: 'Remove address',
        searchResults: 'Search results',
        updatingFeedLocation: 'Your location will be updated.',
    },
    mailbox: {
        goBackButtonTitle: 'Back to the mailbox',
        homepage: 'HOME',
        loadMoreMessages: 'Load previous messages',
        mailBox: 'P.O. Box',
        moreMessages: 'further news',
        noConversationSelected: 'No call selected',
        replyPlaceholder: 'Write an answer',
        sendMessageWithNeighbors: 'Exchange ideas with your neighbours',
    },
    mainMenu: {
        appAnnouncement: 'New in the app',
        conversations: 'P.O. Box',
        conversationsNotAvailableBody: 'Unfortunately, you cannot read private messages in the app at the moment.',
        conversationsNotAvailableTitle: 'P.O. Box not available',
        createBlog: 'Add profile',
        setTheme: 'Choose a color mode',
        setThemeButton: 'Color mode',
        spread: 'Invite neighbours',
        themeDark: 'Night',
        themeLight: 'Day',
        themeSystem: 'System setting',
        toProfile: 'My profile',
    },
    manageBlogProfileAdmin: {
        formBodyEnd: ' can help,' +
            'he himself must be registered as a neighbour in the local portal.\n\n' +
            'Once you submit your request, it may take a little bit of time,' +
            'until the administrator is added to your profile.' +
            'But we will take care of it as soon as possible. 👩🔧👷♂️',
        formBodyStart: 'Before someone helps you manage your profile.',
        formSuccessBodyEnd: ' as administrator.' +
            'If you have any questions just send us a message to:',
        formSuccessBodyStart: 'Your request has been sent to the Local Portal Support Team.' +
            'We will get back to you as soon as possible by e-mail as soon as we have',
        formSuccessTitle: 'Yay... soon you can work together!',
        menuDescription: 'Manage profile with multiple users',
        menuName: 'Add administrator',
    },
    map: {
        expandButtonTooltip: 'Full screen',
        failedGetLocationError: 'Oops, where\'d you land? We brought you back to shore.',
        homeButtonTooltip: 'To the hometown',
        locateMeButtonTooltip: 'To the current location',
        locationChangerButtonTooltip: 'relocate',
        searchThisArea: 'In this area discover',
        zoomInButtonTooltip: 'Enlarge',
        zoomOutButtonTooltip: 'Shrink',
    },
    metatags: {
        defaultTag: {
            author: 'Local portal',
            copyright: 'Local portal, Hamburg, Germany',
            description: 'Lokalportal is the platform for local life. Exchange with' +
                'your neighbours and find out at a glance what is happening in your immediate vicinity.',
            email: 'redaktion@lokalportal.de',
            siteName: 'Local portal',
            title: 'Local portal - the platform for local life',
        },
        descriptions: {
            eventsfeed: (locationName) => `All events in ${locationName} and surrounding area.` +
                'Stay up to date with our tips for music, art and culture.',
            groupOverview: 'You are looking for like-minded people with whom you can share your favorite hobby or interests.' +
                'share? In our groups you can exchange ideas with your neighbours on specific topics.',
            newsfeedAdditionalPage: (startIndex, endIndex, locationName) => `Posts ${startIndex} to ${endIndex} ${exports.DASH}` +
                `All news and information from ${locationName} and` +
                'Environment - directly from the newsroom, from clubs, organizations and your neighbors.',
            newsfeedFirstPage: (locationName) => `All news and information from ${locationName} and` +
                'Environment - directly from the newsroom, from clubs, organizations and your neighbors.',
            profilesDirectory: (locationName) => `Discover clubs, organizations, businesses and public jobs in ${locationName} and surrounding areas.`,
            profilesDirectoryCategoryAuthorityProfiles: (locationName) => `Discover clubs, organizations, businesses and public jobs in ${locationName} and surrounding areas.`,
            profilesDirectoryCategoryPressProfiles: (locationName) => `Discover your newsroom in ${locationName} and the surrounding area.`,
            profilesDirectoryCategoryPrivateProfiles: (locationName) => `Discover your neighbors in ${locationName} and surrounding areas.`,
            shapeSponsors: 'Become a partner of the place and your profile now' +
                'gets even more visibility - directly on the start page.',
        },
        titles: {
            categorizedEventsfeed: (locationName, category) => `Events ${exports.DASH}` +
                `${category} ${exports.DASH} ${locationName} ${exports.SITE_NAME}`,
            createProfile: `Add Profile ${exports.SITE_NAME}`,
            detailsPage: (title) => `${title} ${exports.SITE_NAME}`,
            eventParticipating: `My events ${exports.SITE_NAME}`,
            eventParticipations: `List of participants ${exports.SITE_NAME}`,
            eventsfeed: (locationName) => `Events ${exports.DASH} Overview ${exports.DASH} ${locationName} ${exports.SITE_NAME}`,
            groupFeed: (groupName) => `${groupName} ${exports.SITE_NAME}`,
            groupMembers: (groupName) => `${groupName} ${exports.DASH} Members ${exports.SITE_NAME}`,
            groupOverview: (locationName) => `Groups ${exports.DASH} Overview ${exports.DASH} ${locationName} ${exports.SITE_NAME}`,
            locationPicker: `Select Region ${exports.SITE_NAME}`,
            login: `Login ${exports.SITE_NAME}`,
            mailbox: `Mailbox ${exports.SITE_NAME}`,
            newsfeedAdditionalPage: (locationName, currentPage, totalPages) => `Page ${currentPage}/${totalPages} ${exports.DASH} Current from ${locationName} ${exports.SITE_NAME}`,
            newsfeedAdditionalPageIn: (place, currentPage, totalPages) => `Page ${currentPage}/${totalPages} ${exports.DASH} Current from ${place}`,
            newsfeedFirstPage: (locationName) => `News from ${locationName} ${exports.SITE_NAME}`,
            newsfeedFirstPageIn: (place) => `News from ${place}`,
            notFound: 'Sorry, the page was not found',
            notifications: `Notifications ${exports.SITE_NAME}`,
            privateProfile: `Neighbor Profile ${exports.SITE_NAME}`,
            profile: (name) => `${name} ${exports.SITE_NAME}`,
            profileFollowers: `Subscribers ${exports.SITE_NAME}`,
            profilesDirectory: (locationName) => `Discover ${locationName} ${exports.SITE_NAME}`,
            profilesDirectoryCategoryAuthorityProfiles: (locationName) => `Public bodies in ${locationName} ${exports.SITE_NAME}`,
            profilesDirectoryCategoryAuthorityProfilesIn: (place) => `Public bodies in ${place}`,
            profilesDirectoryCategoryPressProfiles: (locationName) => `Your editorial office in ${locationName} ${exports.SITE_NAME}`,
            profilesDirectoryCategoryPressProfilesIn: (place) => `Your editorial office in ${place}`,
            profilesDirectoryCategoryPrivateProfiles: (locationName) => `Your neighbors in ${locationName} ${exports.SITE_NAME}`,
            profilesDirectoryCategoryPrivateProfilesIn: (place) => `Your neighbors in ${place}`,
            profilesDirectoryIn: (place) => `Discover ${place}`,
            recentFolloweesFeed: `Profile posts ${exports.SITE_NAME}`,
            recentGroupsFeed: `Group contributions ${exports.SITE_NAME}`,
            registration: `Register ${exports.SITE_NAME}`,
            resetPassword: `Reset password ${exports.SITE_NAME}`,
            settings: `Settings ${exports.SITE_NAME}`,
            shapeSponsors: `Partner of the site ${exports.SITE_NAME}`,
            topicChat: `Chat ${exports.SITE_NAME}`,
        },
    },
    neighborChat: {
        isTyping: 'writes ...',
        joinChat: 'Join chat',
        messagesTitle: 'Chat',
        neighborsOnline: (count) => `${count} ${count === 1 ? 'user is' : 'users are'} online`,
        neighborsTitle: 'Just online',
        showNeighbors: 'Show users',
    },
    newUserInfoCTA: {
        body: 'Exchange ideas with real neighbors.' +
            'Get up-to-the-minute local news.' +
            'Find events near you.',
        title: 'What\'s new in your neighborhood?',
    },
    newsfeed: {
        highlights: {
            allFollowewPosts: 'Posts of subscribed profiles',
            allGroupPosts: 'Further group contributions',
            moreFolloweePosts: 'More posts from subscribed profiles',
            moreGroupPosts: 'More posts from your groups',
            mostInteracted: (locationShapeName) => `Talking about that ${locationShapeName}`,
            mostViewed: (locationShapeName) => `That interests ${locationShapeName}`,
            newsFromTheLast24Hours: 'News from the last 24 hours',
            recentFolloweePostsTitle: 'Subscribed:',
            recentGroupPostsTitleFallback: 'Group',
        },
        loadingError: 'The posts could not be loaded.',
        moreItemsInPostGroup: (count) => `${count}` + (count === 1 ? ' weiterer Beitrag' : ' more contributions\') + \' from this neighbour'),
        noNewsAvailable: 'There are no posts here yet.',
    },
    notification: {
        defaultInitiatorName: 'A user',
        eventParticipationEnd: 'part.',
        eventParticipationStart: 'takes part in your event',
        followeeEvent: (teaserAvailable) => teaserAvailable
            ? 'hat eine neue Veranstaltung erstellt: '
            : 'has created a new event.',
        followeePost: (teaserAvailable) => teaserAvailable
            ? 'hat einen neuen Beitrag erstellt: '
            : 'created a new post.',
        loadingError: 'The notifications could not be loaded.',
        newFollower: 'is following you now.',
        noneYet: 'You don\'t have notifications yet.',
        notificationBookmark: 'has gone up to',
        notificationBookmarkableTypeComment: 'your comment',
        notificationBookmarkableTypeEvent: 'your event',
        notificationBookmarkableTypePost: 'your contribution',
        notificationComment: 'has',
        notificationCommented: 'Commented.',
        notificationGroupPostEnd: ' created:',
        notificationGroupPostStart: 'has made a contribution to the group',
        notificationMessage: 'wrote you a new message.',
        notificationReacted: 'Responds.',
    },
    onboardingSettings: {
        action: 'Action',
        address: 'Address',
        addressCorrect: 'Is the address correct?',
        addressStopperText: 'If you have moved, please send us a message' +
            'to the following e-mail address. We will then send the removal van. 🚐',
        adjustYourArea: 'Adapt your area of responsibility',
        alreadyExistPhoneNumber: 'The phone number cannot be used.',
        backToPost: 'Back to the post',
        birthday: 'Date of birth',
        birthdayFormat: 'DD.MM.YYYY',
        blockedNeighbors: 'Blocked neighbors',
        business: 'Company & Service Provider',
        businessDescription: 'Retail, trade...',
        cannotUseEmailAddress: 'E-mail address cannot be used.',
        category: 'Category',
        changeAddress: 'Change address',
        changePasswordBodyText: 'Just click on the button below,' +
            'then we will send you an email to reset your password.',
        changePasswordTitle: 'Change password',
        changeYourPhoto: 'Change your image',
        checkYourEmailForUpdatingEmail: 'Please confirm your e-mail address by' +
            'click on the link in your email.',
        chooseCategory: 'Please choose a category',
        chooseProfile: 'How would you like to participate?',
        collected: 'Collected',
        comments: 'Comments',
        completeProfileBody: 'In order to use our app, you must first complete your profile.\n' +
            'To do this, go to your settings on our website.',
        completeProfileButton: 'Go to lokalportal.de',
        completeProfileTitle: 'You want to have a say too?',
        connections: 'Connections',
        contactNumber: 'Phone number',
        contactPerson: 'Contact',
        contactPersonLopo: 'Sabrina Krause',
        contactUsEmail: 'hilfe@lokalportal.de',
        contactUsSubheadline: 'Your contact person',
        correctVerificationCode: 'That worked! The confirmation code you entered is correct.',
        createProfileStepsHeadline: 'Come on in',
        dailyUpdateEmailHeadline: 'News from',
        dailyUpdateEmailInfo: (location) => 'What new neighbours are there in your' +
            'Neighborhood and what they\'re talking about. In our regular email you will find out exactly that.' +
            'Here you can set whether you want us to send you regular e-mails about the latest news from' +
            `${location} should inform.`,
        dateFormat: 'DD.MM.YYYY',
        deleteAccount: 'Delete user account',
        deleteAccountInfo1: 'If you click on "Delete user account", all your profiles with all personal data will be deleted.' +
            'data and content (posts, comments, events), irrevocably deleted.',
        deleteAccountInfo2: 'Please confirm the deletion of your user account with your password.' +
            'It can take up to 30 days for all your data to be completely deleted.',
        deleteAccountInfo3: 'You have several profiles, but you only want to delete one of them?' +
            'Then drop us a line at:',
        deleteAccountPasswordError: 'Please enter your current password.',
        description: 'Intro text',
        doItLater: 'I\'ll do that later',
        dontForgetYourHouseNumber: 'Don\'t forget your house number!',
        dontMissAnyNews: 'Don\'t miss any more news!',
        dontWorryItsNotVisible: 'Don\'t worry! Your address is not visible to other users.',
        emailAddressChange: 'Change email address',
        emailChangeError: 'An error occurred while changing the email address.',
        emailChangeSuccess: 'Your email address has been successfully changed.',
        emailRegistrationError: 'An error occurred while confirming the email address.',
        emailRegistrationSuccess: 'Your email address has been successfully confirmed.',
        emptyFolloweeListButton: 'Click here to search',
        emptyFolloweeListInfo: 'You have not subscribed to any profiles yet. Have a look in our search' +
            'there you will find many exciting profiles that you can follow. So you always stay' +
            'about their news.',
        enterCode: 'Enter your confirmation code',
        extendedOptions: 'Advanced settings',
        facebookRegistrationError: 'An error occurred during registration.',
        female: 'Female',
        firstLookAround: 'First browse',
        firstLookAroundNow: ' Now browse first',
        firstName: 'First name',
        firstNameEmpty: 'Please state your first name.',
        followedProfiles: 'Subscribed profiles',
        further: 'More',
        furtherSettings: 'Other settings',
        giveYourContactNumber: 'Enter your contact number (optional)',
        giveYourContactPerson: 'Specify a contact person',
        giveYourImpressum: 'Enter your imprint (optional)',
        giveYourInternetSite: 'What is your website (optional)',
        hiddenNeighbors: 'Hidden neighbours',
        iHaveAlreadyCode: 'I already have a code',
        immediately: 'Immediately',
        infocardAddressTitle: 'News from your immediate vicinity',
        infocardDateOfBirthBody: 'The indication of your date of birth is voluntary.' +
            'Your birthday is not visible to other neighbors.',
        infocardDateOfBirthTitle: 'Only if you want to...',
        infocardNameBody: 'Real neighbors with real names lead to much nicer interactions' +
            'and a trustful exchange in the local portal.' +
            'Your neighbors will be happy to know who they\'re talking to.',
        infocardNameTitle: 'Who is this Hans Wurst?',
        internetSite: 'Website',
        internetSiteError: 'The website is not valid',
        introduceYouToYourNeighbor: 'Introduce yourself to your neighbors (optional)',
        invalidName: 'Two letters must follow each other.',
        invalidPhoneNumber: 'The phone number is not valid',
        invalidVerificationCode: 'The confirmation code is not valid',
        lastAttempt: 'You have one more try!',
        lastName: 'Last name',
        lastNameEmpty: 'Please state your last name.',
        letsGo: 'Get right on it!',
        letterNotReceived: 'You gave your address correctly, but no mail yet.' +
            'from us? Then please write us a message to:',
        male: 'Male',
        mutedProfiles: 'Muted profiles',
        myInterests: 'My interests',
        myInterestsInfo: 'State your interests and find like-minded people to hang out with.' +
            'about your favorite topics. Not interested yet?' +
            'Send us your proposal now as',
        name: 'Name',
        neighbor: 'Neighbour',
        neighborDescription: 'For private individuals',
        newEmailAddress: 'New email address',
        newProfile: 'Create new profile',
        newProfileInfo: 'Do you want to create another profile?' +
            'Choose whether you want to create a private or public profile.',
        newsletter: 'Newsletter',
        newsletterInfo: 'In our newsletter we keep you informed about interesting contributions from' +
            'about promotions and new features in your area.' +
            'to set whether you want to receive these emails on a regular basis.',
        noAlwaysEditable: 'No (can be changed at any time)',
        notAvailableMessage: 'Some settings could not be loaded.',
        notSavedCorrectly: 'Saving did not work',
        notifications: 'Notifications',
        organisation: 'Organization',
        organisationDescription: 'Associations, initiatives...',
        other: 'Other',
        phone: 'Phone number',
        post: 'Letter',
        postCardSend: 'You\'ve got mail!',
        postCardSendInfo1: 'We\'ll send you a letter to',
        postCardSendInfo2: '. He should be with you within 7 days.',
        postCardWaring: 'In order for our letter to reach you, please provide your complete address.' +
            'Make sure you haven\'t forgotten your house number.',
        profile: 'Profile',
        profileDescriptionPlaceholder: 'Introduce yourself to your neighbors.',
        profileName: 'Profile name',
        profilePicture: 'Profile picture',
        profileSetting: 'Profile settings',
        profileTypeAssociation: 'Organization',
        profileTypeBlogger: 'Public person',
        profileTypeBusiness: 'Business',
        publicPerson: 'Public persons',
        publicPersonDescription: 'Bloggers, writers, artists...',
        publicProfile: 'Public profile',
        publicProfileChoice: 'For associations, initiatives, companies etc.',
        publicProfileContent: 'We help with the creation of a public profile.' +
            'Please contact us directly as the contact person of a public body.',
        publicProfileDescription: 'Government offices, police, fire department...',
        publicProfileHeader: 'public body',
        publisher: 'Publicists',
        publisherDescription: 'Publishers, editors, magazines...',
        reactions: 'Reactions',
        regularyEmails: 'Regular emails',
        requestVerification: 'Request confirmation code',
        responsibilityArea: 'Area of responsibility',
        responsibilityAreaContent: 'We are always happy to help with questions or change requests',
        returnToLogin: 'Back to registration',
        securityIsImportant: 'Safe is safe',
        selectCategories: 'Choose up to 3 categories',
        sendMeCodeWithPost: 'Send me a code by letter',
        sendMeCodeWithSMS: 'Send me a code by SMS',
        sentMail: 'We have sent you the confirmation email again.',
        sms: 'SMS',
        smsCodePending: 'We sent you a text message with a confirmation code.',
        smsInfoMail: 'hallo@lokalportal.de',
        smsInfoText1: 'If you have entered a wrong number, please write us a message to',
        smsInfoText2: 'so that you can complete your registration.',
        smsVerificationCode1: 'We sent you an SMS with a confirmation code to',
        smsVerificationCode2: ' sent.',
        smsVerificationCode3: 'You didn\'t receive a text message? Please',
        smsVerificationCode4: 'try again here.',
        smsVerificationNoAttempts1: 'Oopsie... that was your last try. But don\'t worry! Just write us a' +
            ' Message to',
        smsVerificationNoAttempts2: ' and we\'ll help you out.',
        smsVerificationNoAttempts3: 'Alternatively, we will be happy to send you a confirmation code by mail.',
        splashNewsletterMessage: 'Would you like us or our partners to send you regularly' +
            'inform me about new contributions by e-mail?',
        splashSuccessAssociation: 'Introduce your organization and tell what makes it special.',
        splashSuccessBlogger: 'Greet your neighbors and introduce yourself to your neighborhood.',
        splashSuccessBusiness: 'Present your business and draw attention to promotions and offers.',
        splashSuccessPrivate: 'Introduce yourself to your neighbors and share your latest news with them.',
        toBriefVerification: 'For letter verification',
        uploadYourPhoto: 'Upload a picture (optional)',
        verification: 'Verification',
        verificationCode: 'Confirmation code',
        verified: 'Verified',
        verifyYourVerificationCode: 'So that we can make sure that you\'re a real' +
            'neighbor, please verify yourself with a confirmation code.',
        viewCountNotify: 'Impressions',
        weNeedYourAddress: 'So we can match you to your neighborhood,' +
            'we need your address.',
        welcomeToLopo: 'Welcome to the local portal!',
        welcomeToNeighborhood: 'Welcome to your neighborhood',
        whatIsYourName: 'What\'s your name?',
        whatIsYourProfileName: 'What do you want your profile to be called?',
        writeAPost: 'Write your first post',
        youCanDeleteAccount: 'Here you can delete your user account',
        youGotEmail: 'You\'ve got mail!',
        yourAddress: 'Your address',
        yourAddressIsNotPublic: 'Your address is not publicly visible',
        yourAddressIsPublic: 'Address of your public profile',
    },
    pageTitles: {
        addProfile: 'Add profile',
        eventParticipants: 'List of participants',
        eventParticipatingFeed: 'Events',
        eventfeed: 'Events for',
        eventfeedSimple: 'Events',
        events: 'Events:',
        followers: 'Subscribers',
        for_: ' for',
        groupFeed: (groupName) => `Group: ${groupName}`,
        groupOverview: 'Groups',
        inbox: 'P.O. Box',
        locationPicker: 'Select region',
        newsfeed: 'News for',
        newsfeedSimple: 'News',
        notifications: 'Notifications',
        profile: 'Profile',
        profileSearch: 'Search for',
        profileSearchSimple: 'Search',
        recentFolloweesFeed: 'Profile posts',
        recentGroupsFeed: 'Group contributions',
        resetPassword: 'reset password',
        settings: 'Settings',
        shapeSponsors: 'Partner from',
        signIn: 'Log in',
    },
    postCreate: {
        addEndDate: 'Add end date',
        addEventCategory: 'Please select a category',
        addPictureActionSheetHeader: 'Add a photo',
        addressSubmenuTitle_APP: 'Address or place',
        addressSubmenuTitle_WEB: 'Address',
        cameraPermissionErrorBody: 'Allow us access to your camera first.' +
            'To do this, go to your settings.',
        cameraPermissionErrorTitle: 'Local portal does not have access to your camera',
        cameraRoll: 'Gallery',
        campaignAddOffer: 'Present your current offers',
        campaignBillingButton: 'Apply contribution with costs',
        campaignBillingHeadline: 'Overview',
        campaignBillingTermsOfUse: 'I confirm the',
        campaignBillingText1: 'We will send you an invoice to the address you entered in your profile when you registered.' +
            'With a click on the button your contribution will be published in the local portal and will be marked with',
        campaignBillingText2: ' promoted for 24 hours on Facebook, Instagram and Google.',
        campaignBillingTitle: 'Payment',
        campaignDeletePostTooltip: 'Ads cannot be deleted.',
        campaignError: 'Unfortunately, this operation could not be performed.',
        campaignErrorDeletePost: 'Delete post',
        campaignErrorHeadline: 'Error',
        campaignErrorKeepPost: 'Keep contribution',
        campaignErrorText1: 'Your post was published but unfortunately could not be promoted. As long as' +
            'it was not successfully advertised, we will of course not charge you for the advertising costs. Try' +
            'just do it again! You can also keep your post without promoting it or delete it.',
        campaignErrorText2: 'If you have any questions, feel free to send us a message to',
        campaignErrorTryAgain: 'Apply contribution',
        campaignIntroDuration: '24 hours',
        campaignIntroFooter: 'You can find more information about the ad in the',
        campaignIntroHeadline: 'Reach the people who are important for your business',
        campaignIntroSocialMeda: 'social media channels',
        campaignIntroTermsOfUse: 'Terms of use',
        campaignIntroText1: 'Promote your current offers and services quickly and easily with an' +
            'Advertise and bring people from your area directly into your store.',
        campaignIntroText2_1: 'Your contribution will not only be published in the local portal, but for',
        campaignIntroText2_2: ' on the known',
        campaignIntroText2_3: ' advertised - and for only',
        campaignIntroText3: 'This way you can reach your customers no matter where they are.',
        campaignPreviewTitle: 'Preview',
        campaignSubmitting: 'Promote contribution locally',
        campaignSuccessButtonNewsfeed: 'Back to the newsfeed',
        campaignSuccessButtonPost: 'Show post',
        campaignSuccessHeadline1: 'Great, that worked!',
        campaignSuccessHeadline2: 'You want even more reach?',
        campaignSuccessText1: 'Your post will be published and shared for 24 hours on Facebook, Instagram and Google' +
            'advertised.',
        campaignSuccessText2: 'Thank you for your order!',
        campaignSuccessText3: 'Share your post!',
        campaignSuccessTitle: 'Confirmation',
        campaignWarningText1: 'After you have advertised your ad for a fee, you can only',
        campaignWarningText2: ' edit. On Facebook, Instagram and Google, your ad cannot be edited afterwards.' +
            'be adjusted more.',
        campaignWarningText3: 'Advertisements can no longer be deleted afterwards',
        campaignWarningTitle: 'Attention!',
        campaignWriteMedia: 'What would your ad be without an appealing picture?',
        cancelMessage: 'Your post isn\'t finished yet. Do you really want to leave the window,' +
            'without finishing your paper?',
        cancelTitle: 'Do you want to leave the window?',
        closeWindow: 'Exit window',
        commentsTitle: 'Allow comments?',
        continueWritingPost: 'Continue post',
        createEventSubtitle: '... and already it is in the calendar',
        createEventTitle: 'Create an event',
        createPostSubtitle: 'Tell everyone from your town',
        createPostTitle: 'What\'s up?',
        descriptionIsMissing: 'Please enter a description.',
        descriptionOptionalPlaceholder: 'Description (optional)',
        descriptionPlaceholder: 'Share news with your neighbors',
        endDate: 'End date',
        endDateRequired: 'Please enter an end date.',
        endDateShouldNotBeforeStartDate: 'The end date must not be earlier than the start date.',
        endTime: 'End Time',
        endTimeNotInThePast: 'Don\'t tell me you can go back in time?! 😱',
        endTimeRequired: 'Please enter an end time',
        eventDescriptionPlaceholder: 'Description',
        flagPost: 'Report post',
        guideText: 'Keep your neighbors up to date! Share news and observations' +
            'them and post pictures that you like.',
        guideTextCampaign: 'Create an ad now and get even more reach!',
        guideTextNew: 'New now:',
        guideTitle: 'What do you want to do?',
        headerCategory: 'Category',
        headerDate: 'Date',
        headerPosition: 'Location',
        headerPreview: 'Preview',
        imageCropperButtonBigger: 'Larger',
        imageCropperButtonRotate: 'rotate',
        imageCropperButtonSmaller: 'small',
        imageCropperButtonTitleImage: 'Cover',
        imageCropperTitle: 'Edit image',
        imageGalleryPermissionErrorBody: 'Allow us to access your gallery first.' +
            'To do this, go to your settings.',
        imageGalleryPermissionErrorTitle: 'Local portal does not have access to your photos and videos',
        imageSelectionErrorBody: 'An error occurred while adding the photo.',
        lessThanThreeDays: 'An event may not last longer than 3 days.',
        mediaDeleteButton: 'Delete image',
        mediaMaxImages: (maxImages) => `max ${maxImages} images`,
        mediaMaxImagesError: (maxImages) => `Unfortunately you can't upload more than ${maxImages} images.`,
        mediaMaxImagesGenericError: 'Sorry, you can\'t upload more pictures.',
        mediaPermissionErrorBody: 'Allow us to access your camera and gallery first.' +
            'To do this, go to your settings.',
        mediaPermissionErrorTitle: 'Local portal has no access to your media',
        mediaSelectSubtext: 'Add now',
        mediaSelectText: 'Embellish your post with pictures.',
        mediaTitle: 'Photos',
        moreMediaPlural: 'more pictures',
        moreMediaSingular: 'another picture',
        postSubmitting: 'Your contribution will be published.',
        previewLoadingError: 'The preview could not be loaded.',
        previewMessage: (location) => `Your post is visible in ${location}.`,
        previewText: 'Are you happy with that?',
        removeEndDate: 'Remove end date',
        removePreviewLink: 'Remove link preview',
        selectSubtitleCampaign: 'Contribution with increased range',
        selectSubtitleEvent: 'Public event or meeting',
        selectSubtitlePublicPost: 'Publicly visible contribution',
        selectSubtitleSnapshot: 'Photo format for all images',
        selectSubtitleSurvey: 'Create a survey',
        selectTitlePublicPost: 'Post',
        shareYourInformation: 'Spread your current information',
        snapshotLocationBody: 'Show your neighbors where your snapshot was taken,' +
            'so they can visit this place too.',
        snapshotLocationTitle: 'Where did you take your picture?',
        startDate: 'Start date',
        startDateRequired: 'Please enter a start date.',
        startDateShouldNotBeThePast: 'The event must be in the future.',
        startTime: 'Initial time',
        startTimeRequired: 'Please enter a start time.',
        surveyAnswersTitle: 'Answers',
        surveyCreateButton: "Create survey",
        surveyDatepickerPlaceholder: "Set date",
        surveyDatepickerTitle: "Set end date",
        surveyOption: (index) => `Option ${index}`,
        surveyOptionAdd: "Add answer",
        surveyQuestionPlaceholder: "Title",
        surveyQuestionTitle: "Question",
        surveySubmitting: 'Your survey will be published.',
        takePicture: 'take a picture',
        titleIsMissing: 'Please enter a title.',
        titlePlaceholder: 'Headline',
        whereToPin: 'Where do you want your pin on the card?',
        writeTitleCampaign: 'Advert',
    },
    postDetail: {
        relatedContentSubtitle: 'This might also interest you',
        relatedContentTitle: 'More contributions',
        source: 'Source',
        tickets: 'Tickets',
    },
    postTypes: {
        event: 'Event',
        groupPost: 'Group contribution',
        publicPost: 'Post',
        snapshot: 'Snapshot',
        survey: 'Survey',
    },
    premiumContentInfo: {
        body: 'You would like to read all contributions in the local portal? Simply register for free.',
        bodyTitle: 'Join and become part of Lokalportal!',
        bullet1: 'Receive exclusive local news',
        bullet2: 'Exchange ideas with your neighbours',
        bullet3: 'Find events near you',
        title: 'Read more for free',
    },
    profile: {
        aboutMe: 'About me:',
        authorityProfile: 'Verified authority',
        blog: 'Page',
        blogProfile: 'Page off',
        blurredLoggedOutBody: 'After all, the beauty of getting to know each other is that it always takes two. \n' +
            'Therefore, you can only see profiles of neighbors,' +
            'once you\'ve registered on the local portal.',
        blurredLoggedOutBodyTile: (profileName) => `You want to get to know ${profileName} better?`,
        editProfile: 'Edit profile',
        extensionAuthority: 'Public profiles',
        extensionBlog: 'Pages',
        extensionPress_APP: 'Your local newsroom',
        extensionPress_WEB: 'Editorial',
        extensionPrivate: 'Neighbors',
        extensionUnknown: '',
        giveYourInterests: 'Specify your interests and find like-minded people with whom' +
            'you can exchange ideas on certain topics.',
        myInterests: 'My interests:',
        neighborFromFemale: 'Neighbor from',
        neighborFromMale: 'Neighbor from',
        neighborMale: 'Neighbor',
        press: 'Editors',
        pressProfile: 'Editors from',
    },
    profileList: {
        orderBy: 'Sorted by:',
        orderByAccessionDate_APP: 'Accession date',
        orderByAccessionDate_WEB: 'Date of accession (latest first)',
        orderByName: 'Name',
        orderDirectionAscendingDate: 'oldest first',
        orderDirectionAscendingName: 'ascending',
        orderDirectionDescendingDate: 'newest first',
        orderDirectionDescendingName: 'descending',
    },
    profileSearch: {
        relatedContentSubtitle: 'You might also be interested in this.',
        searchAndDiscover: 'Search and discover',
    },
    pushNotification: {
        permissionAlertBody: 'If you allow notifications, you will no longer miss any news from' +
            'of your neighborhood. You can turn it off at any time in the settings.',
        permissionAlertCancelAction: 'Do not allow',
        permissionAlertPositiveAction: 'Allow',
        permissionAlertTitle: 'Push notifications',
    },
    rateTheApp: {
        addRating: 'submit evaluation',
        doYouLikeLopo: 'Do you like Lokalportal?',
        no: 'No',
        notYet: 'Not now',
        rateTheAppBody: 'Rate the Local Portal app in the Google Play Store.',
        rateTheAppTitle: 'Yay! Then we are happy about your review.',
        yes: 'Yes',
    },
    reactions: {
        condolences: 'My condolences',
        countInfo: (profileName, count) => {
            const maxCharacters = 14;
            let truncatedName = profileName;
            if (profileName.length > maxCharacters) {
                truncatedName = profileName.substring(0, maxCharacters) + '...';
            }
            switch (count) {
                case 1:
                    return profileName;
                case 2:
                    return `${truncatedName} and 1 other neighbor`;
                default:
                    return `${truncatedName} and ${count - 1} other neighbors`;
            }
        },
        emptyReactions: 'There are no responses to this post yet.',
        haha: 'Funny',
        interesting: 'Interesting',
        like: 'I like',
        ohNo: 'Sad',
        reactions: 'Reactions',
        title: 'What do you think of this post?',
        wow: 'Wow',
    },
    relatedContent: {
        headline: 'More contributions',
        subHeadline: 'This might also interest you',
    },
    reloadPage: {
        message: 'There is a new version of Lokalportal. Please reload the page,' +
            'so that you can continue to use Lokalportal.',
        reload: 'Reload',
    },
    screenReaderText: {
        addMorePictures: 'Add more images',
        administrator: 'Administrator',
        close: 'Close',
        closeChat: 'Close chat',
        closeMap: 'Close map',
        message: 'News',
        moreOptions: 'More options',
        new: ' new',
        nextDay: 'Next day',
        nextMonth: 'Next month',
        nextYear: 'Next year',
        notification: 'Notifications',
        openCalendar: 'Open calendar',
        openChat: 'Open chat',
        openMap: 'Open map',
        openMenu: 'Open menu',
        photoGallery: 'Photo gallery',
        previousDay: 'Previous day',
        previousMonth: 'Previous month',
        previousYear: 'Previous year',
        stepCompleted: 'Step completed',
        titlePicture: 'Cover',
        viewMessage: 'View message',
    },
    shapeSponsors: {
        bronzePartner: 'Partners of the place',
        formBody: 'You want your profile to be the center of attention? As a partner of the place your profile picture appears' +
            'at the top of our home page and is visually highlighted. You get so easily' +
            'even more visibility.\n\n' +
            'You would like to become a partner of the site or you still have questions? Write us a short message and our' +
            'Editors will get back to you as soon as possible. If you like, write your phone number' +
            'and it\'ll go even faster. ☎',
        formSuccessBody: 'We\'ll get back to you as soon as we can!',
        formSuccessTitle: 'Your message is on its way',
        formTitle: 'Become a partner of the place!',
        inputErrorText: 'Please enter your message.',
        inputPlaceholder: 'Your message',
        silverPartner: 'premium partner',
        title: 'Partners of the place',
    },
    share: {
        email: 'Email',
        facebook: 'Facebook',
        greeting: 'Do you already know Lokalportal, the platform for local life?\n' +
            'I\'m already exchanging ideas with my neighbors there.' +
            'Join in and register now for free on \n',
        link: 'Link',
        linkWasCopiedToClipboard: 'The link has been copied to the clipboard.',
        share: 'Share',
        subject: 'I want to invite you to the local portal!',
        twitter: 'Twitter',
        whatsapp: 'WhatsApp',
    },
    shared: {
        aboutUs: 'About us',
        addInterests: 'Add interests',
        and: 'and',
        back: 'Back',
        blog: 'Blog',
        cancel: 'Cancel',
        close: 'Close',
        continue: 'Go to',
        delete: 'Delete',
        done: 'Ready',
        edit: 'Edit',
        email: 'E-mail address',
        emptyFeedText: 'Unfortunately, there are no contributions here yet.',
        emptyListText: 'Unfortunately, there is nothing interesting to see here at the moment.',
        errorEmail: 'Please check your email address.',
        errorUnknown: 'Oops... something went wrong.',
        faq: 'FAQ',
        feedback: 'Feedback',
        forMe: 'For me',
        formAssistiveText: 'Please separate multiple addresses with commas.',
        formErrorInvalid: 'There\'s been a mistake',
        genericErrorBody: 'Something went wrong with the last action.',
        genericErrorLong: 'Oops... something went wrong.\nTry again please.',
        genericErrorTitle: 'Oops...',
        helpEmail: 'hilfe@lokalportal.de',
        hereIsMore: 'Here\'s some more!',
        imageAddError: 'Oops... an error occurred while adding a picture!',
        imprint: 'Imprint',
        inputTooShort: (minCharacters) => `Please enter at least ${minCharacters === 1 ? 'on' : minCharacters} characters.`,
        jobs: 'Jobs',
        learnMore: 'More about local portal',
        login: 'Log in',
        logout: 'Logout',
        lokalportal: 'Local portal',
        lokalportalSite: 'localportal.de',
        maxCharacters: (maxCharacters) => `max. ${maxCharacters} characters`,
        neighborhood: 'Neighborhood',
        never: 'Never',
        newVersion: 'A new version is available',
        noLocalResultFound: 'Unfortunately no results could be found in this region.',
        noResultFound: 'Unfortunately no results could be found.',
        ok: 'OK',
        or: 'or',
        pageNotFound: 'Oh dear... unfortunately the post could not be found.',
        paginationButtonTitle: (page) => `Page ${page}`,
        password: 'Password',
        period: '.',
        privacy: 'Data protection',
        register: 'Register',
        registerNow: 'Register now',
        required: '*mandatory field',
        retry: 'Try again',
        save: 'Save',
        sayHello: 'Say hello!',
        send: 'Send',
        settings: 'Settings',
        showAll: 'Show all',
        submit: 'Submit',
        terms: 'AGB',
        understood: 'Roger',
        verify: 'Verify',
        version: 'Version',
        welcomeBack: 'Welcome back',
        writeMessage: 'Write message',
        yes: 'Yes',
    },
    spread: {
        formFieldEmailsPlaceholder: 'E-mail address(es)',
        formFieldMessagePlaceholder: 'Your invitation text',
        formFieldSenderPlaceholder: 'Your name',
        formIntro: 'Tell your neighbors and friends about Lokalportal. The more neighbors there are,' +
            'the more momentum there is.',
        formOptional: 'Optional',
        formSubmitButton: 'Send invitation',
        formTitle: 'Are your neighbors on board yet?',
        shareIntro: 'Share Lokalportal with your friends:',
        thanksMessage: 'Your invitation has been sent. We\'re glad you\'re helping out,' +
            'To make your neighborhood even more vibrant. 🤗',
        thanksTitle: 'Great, that worked!',
    },
    welcomeScreen: {
        backtoPost: 'Back to the post',
        completeProfileSubtitle: 'Show your chocolate side',
        completeProfileTitle: 'Complete profile',
        followProfilesSubtitle: 'Don\'t miss any news',
        followProfilesTitle: 'Follow profiles',
        headerTitle: 'Welcome',
        joinGroupsSubtitle: 'Find groups near you',
        joinGroupsTitle: 'join groups',
        title: 'Discover Local Portal and your neighborhood.',
    },
    wizard: {
        request: 'Request',
        send: 'Send',
        start: 'Start now',
    },
};
